import { useEffect, useState } from 'preact/hooks';
import NavRecommenderIconChatbot from './navRecommenderIconChatBot';
import NavChatbotIconChatbot from './navChatbotIconChatbot';


export default function ChatBotNavChatbot({navigationState}){

  return (
    <>
      <ul className='bot-utn-app-navigation'>
        <li onClick={() => { navigationState.value = 0}}>
          <NavChatbotIconChatbot 
            isSelected={navigationState.value === 0} 
          />
        </li>
        <li onClick={() => { navigationState.value = 1}}>
          <NavRecommenderIconChatbot 
            isSelected={navigationState.value === 1} 
          />
        </li>
      </ul>
    </>
    );
}
